import { render, staticRenderFns } from "./LockSemesterForm.vue?vue&type=template&id=570a73bd"
import script from "./LockSemesterForm.vue?vue&type=script&lang=js"
export * from "./LockSemesterForm.vue?vue&type=script&lang=js"
import style0 from "./LockSemesterForm.vue?vue&type=style&index=0&id=570a73bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports